module.exports = __webpack_public_path__ + "static/media/ship_with_water.876623c4.png";